/**
 * Shooting, Editing & Lighting Styles Section for Assistant Profile
 * Allows selection of preferred styles across all three categories
 */
import { Card } from "@/components/ui/card";
import { SHOOTING_STYLES, EDITING_STYLES, LIGHTING_STYLES } from "@/lib/profileOptions";

function StyleGrid({ title, description, options, selected, onToggle, testIdPrefix }) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-1">{title}</h2>
      {description && <p className="text-white/50 text-sm mb-6">{description}</p>}
      <div className="flex flex-wrap gap-3">
        {options.map((item) => {
          const isSelected = selected.includes(item.value);
          return (
            <button
              key={item.value}
              type="button"
              onClick={() => onToggle(item.value)}
              className={`px-4 py-2 rounded-sm transition-all ${
                isSelected 
                  ? "bg-white text-black" 
                  : "bg-white/10 text-white/60 hover:bg-white/20 border border-white/10"
              }`}
              data-testid={`${testIdPrefix}-${item.value}`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </Card>
  );
}

export default function ShootingStylesSection({ 
  shootingStyles, setShootingStyles,
  editingStyles, setEditingStyles,
  lightingStyles, setLightingStyles
}) {
  const toggle = (list, setter) => (value) => {
    if (list.includes(value)) {
      setter(list.filter(s => s !== value));
    } else {
      setter([...list, value]);
    }
  };

  return (
    <>
      <StyleGrid
        title="Preferred Shooting Styles"
        description="Select the shooting styles you're most comfortable with"
        options={SHOOTING_STYLES}
        selected={shootingStyles}
        onToggle={toggle(shootingStyles, setShootingStyles)}
        testIdPrefix="shooting-style"
      />
      <StyleGrid
        title="Editing Styles"
        description="What editing look do you deliver?"
        options={EDITING_STYLES}
        selected={editingStyles || []}
        onToggle={toggle(editingStyles || [], setEditingStyles)}
        testIdPrefix="editing-style"
      />
      <StyleGrid
        title="Lighting Styles"
        description="What lighting setups are you experienced with?"
        options={LIGHTING_STYLES}
        selected={lightingStyles || []}
        onToggle={toggle(lightingStyles || [], setLightingStyles)}
        testIdPrefix="lighting-style"
      />
    </>
  );
}
